import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import AddBoxIcon from '@material-ui/icons/AddBoxOutlined';

const styles = theme => ({
  card: {
    position: 'fixed',
    zIndex: 9999,
    bottom: 0,
    width: '100%',
    background: '#fff',
    padding: '1rem',
    textAlign: 'left',
    lineHeight: 2.7,
    fontSize: '1.1rem',
    boxShadow: '0 0 3px 0 rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.5s',
    height: '5.125rem',
    opacity: 1
  },
  cardExpanded: {
    height: '16.875rem'
  },
  cardDisappearing: {
    opacity: 0
  },
  logo: {
    float: 'left',
    marginRight: '1rem',
    height: '50px'
  },
  instructions: {
    fontSize: '1rem',
    lineHeight: 2,
    width: '100%',
    float: 'left',
    marginTop: '1rem'
  },
  icon: {
    height: '1.1rem',
    margin: '0 2px'
  },
  bold: {
    whiteSpace: 'nowrap'
  },
  btn: {
    fontSize: '1.1rem',
    margin: '5px 5px 15px'
  }
});

class AddToHomeScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      phase: null,
      activated: false
    };
  }

  componentDidMount() {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test( userAgent );
    }

    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
    
    if (isIos() && !isInStandaloneMode()) {
      this.setState({
        active: true,
        phase: 0
      });
    }
  }

  nextPhase() {
    let phase = this.state.phase + 1
    this.setState({phase: phase});
  }

  dismiss() {
    this.setState({phase: 2});

    setTimeout(() => {
      this.setState({active: false});
    }, 500);
  }

  render() {
    if (this.state.active) {
      const { classes, theme } = this.props;

      switch (this.state.phase) {
        case 0:
          return (
            <div className={classes.card} onClick={this.nextPhase.bind(this)}>
              <img className={classes.logo} src="/img/logo-yellow.svg" />
              <span>Add us to your home screen!</span>
            </div>
          );

        case 1:
          return (
            <div className={`${classes.card} ${classes.cardExpanded}`}>
              <img className={classes.logo} src="/img/logo-yellow.svg" />
              <span>Add us to your home screen!</span>
              <p className={classes.instructions}>
                To add us to your home screen, tap the <img className={classes.icon} src="/img/apple-arrow.svg" /> icon in your status bar below, then tap <b className={classes.bold}>Add to Home Screen <AddBoxIcon /></b>.
              </p>
              <button className={`${classes.btn} btn btn-primary float-right`} onClick={this.dismiss.bind(this)}>
                Got it
              </button>
            </div>
          );

         case 2:
          return (
            <div className={`${classes.card} ${classes.cardExpanded} ${classes.cardDisappearing}`}>
              <img className={classes.logo} src="/img/logo-yellow.svg" />
              <span>Add us to your home screen!</span>
              <p className={classes.instructions}>
                To add us to your home screen, tap the <img className={classes.icon} src="/img/apple-arrow.svg" /> icon in your status bar below, then tap <b className={classes.bold}>Add to Home Screen <AddBoxIcon /></b>.
              </p>
              <button className={`${classes.btn} btn btn-primary float-right`}>
                Got it
              </button>
            </div>
          );
      }
    }

    return null;
  }
}

AddToHomeScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

export default withStyles(styles, {withTheme: true})(AddToHomeScreen);
